import angular from 'angular';
import { ReschedulePickupSummaryComponent } from './summary.component';

angular
  .module('app.reschedule-pickup.summary', [])
  .component('reschedulePickupSummary', ReschedulePickupSummaryComponent);
